var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React, { useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { ThemeContext } from "styled-components";
import { ButtonWrapper } from "../atoms/ButtonWrapper";
import { InnerContent } from "../atoms/InnerContent";

var Primary = function Primary(props) {
  var theme = useContext(ThemeContext);

  var children = props.children,
      style = props.style,
      restProps = _objectWithoutProperties(props, ["children", "style"]);

  return React.createElement(
    ButtonWrapper,
    _extends({
      borderColor: "none",
      bgColor: theme.primary
      // height={3.5}
      // borderRadius={4}
      , style: style
    }, restProps),
    React.createElement(
      InnerContent
      // paddingLeft={2}
      // paddingRight={2}
      ,
      _extends({ bgColor: theme.primary,
        textColor: theme.textNegative
      }, restProps),
      children
    )
  );
};

export { Primary };
Primary.propTypes = process.env.NODE_ENV !== "production" ? {
  fluid: PropTypes.oneOfType([PropTypes.bool, PropTypes.array]),
  onHover: PropTypes.func,
  onClick: PropTypes.func
} : {};